import React from "react";
import logo from "../Assets/clinix.png";

const Header = () => {
  return (
    <header className="bg-white px-6 dark:border-slate-800 dark:bg-slate-950">
      <div className="flex shrink-0 items-center gap-3.5">
        <div className="flex h-20 w-20 items-center justify-center">
          <img
            src={logo}
            alt="CLINIX"
            className="h-full w-full object-contain"
          />
        </div>

        {/* 
        <div className="flex flex-col">
          <span className="text-xl font-black tracking-wider text-slate-900 dark:text-white">
            CLINIX
          </span>
          <span className="text-[10px] font-bold uppercase tracking-widest text-blue-600 dark:text-blue-400">
            Smart Healthcare Ecosystem
          </span>
        </div> 
        */}
      </div>
    </header>
  );
};

export default Header;